import { render, staticRenderFns } from "./RadioCard.vue?vue&type=template&id=36e56608&scoped=true&"
import script from "./RadioCard.vue?vue&type=script&lang=js&"
export * from "./RadioCard.vue?vue&type=script&lang=js&"
import style0 from "./RadioCard.vue?vue&type=style&index=0&id=36e56608&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e56608",
  null
  
)

export default component.exports